import React, { ButtonHTMLAttributes } from 'react';
import { ClipLoader } from 'react-spinners';

import { Container } from './styles';

export interface IDialogOptionProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  label?: string;
  optionType?: string;
  marginLeft?: string;
  processing?: boolean;
}

const DialogOption: React.FC<IDialogOptionProps> = ({
  label,
  processing = false,
  ...rest
}) => {
  return (
    <Container type="button" {...rest}>
      {label}

      {processing && <ClipLoader color="#fff" size={20} />}
    </Container>
  );
};

export default DialogOption;
